import {EmployeeEventTypeEnum} from '../enum/employee-event-type.enum';

/**
 * @class
 * @description This class is used to represent the employee event that is triggered.
 * @event
 * @export
 * @name EmployeeEvent
 */
export class EmployeeEvent {

  /**
   * @constructor
   * @description This constructor creates an instance of the EmployeeEvent class.
   * @memberof EmployeeEvent
   * @name EmployeeEvent#constructor
   * @param {EmployeeEventTypeEnum} type This parameter contains the type of event that is being triggered.
   * @public
   */
  public constructor(

    /**
     * @description This property contains the type of event that is being triggered.
     * @memberof EmployeeEvent
     * @name EmployeeEvent#type
     * @property
     * @public
     * @readonly
     * @type {EmployeeEventTypeEnum}
     */
    public readonly type: EmployeeEventTypeEnum
  ) { }
}
